import { graphql, StaticQuery } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";
import { DraftboxAuthor } from "../../models/draftbox-author-description.model";
import { DraftboxWebsiteMetaBasic } from "../../models/draftbox-websitemeta.model";
import FacebookImageMeta from "./FacebookMeta";
import * as buildURL from "build-url";

type AuthorMetaTypes = {
  author: DraftboxAuthor;
  settings: DraftboxWebsiteMetaBasic;
};

const AuthorMeta: React.FC<AuthorMetaTypes> = ({ author, settings }) => {
  const {
    draftboxSettings: { seo, identity },
  } = settings;

  let jsonld = JSON.parse(author.jsonld);
  if (jsonld?.image && author.coverImage) {
    // jsonld.image.url = url.resolve(
    //   identity.siteUrl,
    //   author.coverImage.publicURL
    // );
    jsonld.image.url = new URL(
      author.coverImage.publicURL,
      identity.siteUrl
    ).href;
  }

  return (
    <>
      <Helmet>
        <title>{author.metaTitle}</title>
        <meta name="description" content={author.metaDescription} />
        <meta property="og:site_name" content={identity.siteName} />
        <meta property="og:title" content={author.ogTitle} />
        <meta property="og:description" content={author.ogDescription} />
        <link
          rel="canonical"
          href={buildURL(identity.siteUrl, { path: `author/${author.slug}` })}
        />

        {seo.facebook.appId !== "" && (
          <meta property="fb:app_id" content={seo.facebook.appId} />
        )}
        <meta
          property="og:url"
          content={buildURL(identity.siteUrl, {
            path: `author/${author.slug}`,
          })}
        />

        <meta property="article:tag" content={author.name} />

        <meta name="twitter:title" content={author.twitterTitle} />
        <meta name="twitter:description" content={author.twitterDescription} />

        {author.twitterImage && (
          // <meta
          //   name="twitter:image"
          //   content={url.resolve(
          //     identity.siteUrl,
          //     author.twitterImage?.seo?.fixed?.src
          //       ? author.twitterImage?.seo?.fixed?.src
          //       : author.twitterImage.publicURL
          //   )}
          // />
          <meta
            name="twitter:image"
            content={
              new URL(
                author.twitterImage?.seo?.fixed?.src
                  ? author.twitterImage?.seo?.fixed?.src
                  : author.twitterImage.publicURL,
                identity.siteUrl
              ).href
            }
          />
        )}
        {author.twitterImage && (
          <meta name="twitter:card" content="summary_large_image" />
        )}
        <meta
          name="twitter:url"
          content={buildURL(identity.siteUrl, {
            path: `author/${author.slug}`,
          })}
        />

        {/* TODO: fix jsonld schema before using */}
        <script type="application/ld+json">
          {JSON.stringify(jsonld, undefined, 4)}
        </script>
      </Helmet>
      {author.ogImage && (
        <FacebookImageMeta
          // imageUrl={url.resolve(
          //   identity.siteUrl,
          //   author.ogImage?.seo?.fixed?.src
          //     ? author.ogImage?.seo?.fixed?.src
          //     : author.ogImage.publicURL
          // )}
          imageUrl={
            new URL(
              author.ogImage?.seo?.fixed?.src
                ? author.ogImage?.seo?.fixed?.src
                : author.ogImage.publicURL,
              identity.siteUrl
            ).href
          }
          imageHeight={
            author.ogImage?.seo?.fixed?.src
              ? author.ogImage.seo.fixed.height.toString()
              : null
          }
          imageWidth={
            author.ogImage?.seo?.fixed?.src
              ? author.ogImage.seo.fixed.width.toString()
              : null
          }
          appId={seo.facebook.appId}
        />
      )}
    </>
  );
};

type PostMetaQueryTypes = {
  author: DraftboxAuthor;
};
const AuthorMetaQuery: React.FC<PostMetaQueryTypes> = ({ author }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          draftboxSettings {
            ...DraftboxWebsiteMetadataBasic
          }
        }
      `}
      render={(data) => <AuthorMeta author={author} settings={data} />}
    ></StaticQuery>
  );
};

export default AuthorMetaQuery;
